export default {
  top: [
    {
      name: 'Dashboard', url: '/app', icon: 'lni lni-dashboard', ionicon: '', exact: true, allowed: ['admin'],
    },
	{
      name: 'Collection Entry', url: '/app/collection/new', icon: 'lni lni-pencil', ionicon: '', exact: false, allowed: ['admin'],
    },
    {
      name: 'Update Collection', url: '/app/collection/edit', icon: 'lni lni-pencil', ionicon: '', exact: false, allowed: ['admin'],
    },
	{
      name: 'Customers', url: '/app/customers', icon: 'lni lni-user', ionicon: '', exact: false, allowed: ['admin'],
    },
	{
      name: 'My Profile', url: '/app/profile', icon: 'lni lni-user', ionicon: '', exact: false, allowed: ['admin'],
    },
  ],
  bottom: [
  ],
};
